<section class="row mb-4 pl-2 border-left pt-4">
  <section class="col-sm-12 col-md-6 m-auto border p-0" *ngIf="encuestas_anterior.length == 0 || authService.getTipoUser() === tipo_prestador; else comparativo">
    <ng-container *ngFor="let modulo of encuestas">
      <h2 class="h5 font-weight-bold align-content-center mt-3 bg p-3">{{modulo.descripcion}}</h2>
      <ng-container *ngFor="let seccion of modulo.secciones">
        <h3 class="h6 font-weight-bold ml-3 mr-3 mt-3">{{seccion.descripcion}}</h3>
        <div class="row" *ngFor="let pregunta of seccion.preguntas">
          <ng-container>
            <div class="col-sm-12 col-md-12 mt-1">
              <label class="small text-muted mb-0 ml-3">{{pregunta.descripcion}}<br>
                <ng-container *ngIf="pregunta.tipo_pregunta_encuesta_id !== tipo_pregunta_multiple">
                  <ng-container *ngFor="let opcion of pregunta.opciones">
                    <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_abierta">
                      {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}</strong>
                    <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_unica">
                      {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}</strong>
                    <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_formula">
                      {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}</strong>
                    <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_lista_valor">
                      {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}
                    </strong>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_multiple">
                  <ul *ngFor="let opcion of pregunta.opciones">
                    <li class="h6 font-weight-bold">{{opcion.respuesta}}{{opcion.respuesta_2 ? ' | '+opcion.respuesta_2 : ''}}</li>
                  </ul>
                </ng-container>
              </label>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </section>
  <section class="col-sm-12 col-md-12 mt-2" *ngIf="encuestas.length == 0">
    <div>
      <div class="text-center">
        {{mensajeError}}
      </div>
    </div>
  </section>
  <!-- comparativo -->
  <ng-template #comparativo>
    <section class="col-sm-12 col-md-6 border-right">
      <h3 class="col-12 h5 font-weight-bold mt-1 border-actual">Versión actual</h3>
      <ng-container *ngFor="let modulo of encuestas">
        <h2 class="h5 font-weight-bold align-content-center mt-3 bg p-3">{{modulo.descripcion}}</h2>
        <ng-container *ngFor="let seccion of modulo.secciones">
          <h3 class="h6 font-weight-bold ml-3 mr-3 mt-3">{{seccion.descripcion}}</h3>
          <div class="row" *ngFor="let pregunta of seccion.preguntas">
            <ng-container>
              <div class="col-sm-12 col-md-12 mt-1">
                <label class="small text-muted mb-0 ml-3">{{pregunta.descripcion}}<br>
                  <ng-container *ngIf="pregunta.tipo_pregunta_encuesta_id !== tipo_pregunta_multiple">
                    <ng-container *ngFor="let opcion of pregunta.opciones">
                      <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_abierta">
                        {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}</strong>
                      <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_unica">
                        {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}</strong>
                      <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_formula">
                        {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}</strong>
                      <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_lista_valor">
                        {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}
                      </strong>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_multiple">
                    <ul *ngFor="let opcion of pregunta.opciones">
                      <li class="h6 font-weight-bold">{{opcion.respuesta}}{{opcion.respuesta_2 ? ' | '+opcion.respuesta_2 : ''}}</li>
                    </ul>
                  </ng-container>
                </label>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
      <section class="col-sm-12 col-md-12 mt-2" *ngIf="encuestas.length == 0">
        <div>
          <div class="text-center">
            {{mensajeError}}
          </div>
        </div>
      </section>
    </section>
    <section class="col-sm-12 col-md-6">
      <h3 class="col-12 h5 font-weight-bold mt-1 border-anterior">Versión anterior</h3>
      <section class="opacity">
        <ng-container *ngFor="let modulo of encuestas_anterior">
          <h2 class="h5 font-weight-bold align-content-center mt-3 bg p-3">{{modulo.descripcion}}</h2>
          <ng-container *ngFor="let seccion of modulo.secciones">
            <h3 class="h6 font-weight-bold ml-3 mr-3 mt-3">{{seccion.descripcion}}</h3>
            <div class="row" *ngFor="let pregunta of seccion.preguntas">
              <ng-container>
                <div class="col-sm-12 col-md-12 mt-1">
                  <label class="small text-muted mb-0 ml-3">{{pregunta.descripcion}}<br>
                    <ng-container *ngIf="pregunta.tipo_pregunta_encuesta_id !== tipo_pregunta_multiple">
                      <ng-container *ngFor="let opcion of pregunta.opciones">
                        <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_abierta">
                          {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}</strong>
                        <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_unica">
                          {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}</strong>
                        <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_formula">
                          {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}</strong>
                        <strong class="h6 font-weight-bold" *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_lista_valor">
                          {{opcion.respuesta}}{{opcion.respuesta_2 ? ', '+opcion.respuesta_2 : ''}}
                        </strong>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="pregunta.tipo_pregunta_encuesta_id === tipo_pregunta_multiple">
                      <ul *ngFor="let opcion of pregunta.opciones">
                        <li class="h6 font-weight-bold">{{opcion.respuesta}}{{opcion.respuesta_2 ? ' | '+opcion.respuesta_2 : ''}}</li>
                      </ul>
                    </ng-container>
                  </label>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </section>
      <section class="col-sm-12 col-md-12 mt-2" *ngIf="encuestas_anterior.length == 0">
        <div>
          <div class="text-center">
            {{mensajeError}}
          </div>
        </div>
      </section>
    </section>
  </ng-template>
</section>